/** 견적 조회 오류 중 "찾을 수 없음"으로 보여 줄 tRPC 코드 — 없는 견적(NOT_FOUND)·남의 견적(FORBIDDEN)·잘못된 id(BAD_REQUEST). */
const NOT_FOUND_CODES: ReadonlySet<string> = new Set(['NOT_FOUND', 'FORBIDDEN', 'BAD_REQUEST']);

/**
 * 내 견적 상세·주문하기 화면이 함께 쓰는 판정 — 남의 견적은 존재를 드러내지 않고 못 찾음으로 보여 준다. 그 밖의 오류(일시적 실패)는
 * 다시 시도로 보여 준다.
 */
export const isQuoteNotFoundError = (code: string | undefined): boolean =>
  code !== undefined && NOT_FOUND_CODES.has(code);
